import { useEffect, useState } from "react";
import { ServiceAirFreightSnap } from "./ServiceAirFreightSnap";
import { ServiceAirFreightNormal } from "./ServiceAirFreightNormal";
import { Grid } from "antd";

import { isApplySnap } from "@/utils";
const { useBreakpoint } = Grid;

export function ComponentServiceAirFreight({ pageContent = {} }) {
	const screens = useBreakpoint();
	const [applySnap, setApplySnap] = useState(false);

	useEffect(() => {
		setApplySnap(isApplySnap());
		function orientationChanged() {
			const timeout = 120;
			return new window.Promise(function (resolve) {
				const go = (i, height0) => {
					window.innerHeight != height0 || i >= timeout
						? resolve()
						: window.requestAnimationFrame(() => go(i + 1, height0));
				};
				go(0, window.innerHeight);
			});
		}
		window.addEventListener("orientationchange", function () {
			orientationChanged().then(function () {
				// Profit
				setApplySnap(isApplySnap());
			});
		});
		return () => {
			window.removeEventListener("orientationchange", function () {
				orientationChanged().then(function () {
					// Profit
					setApplySnap(isApplySnap());
				});
			});
		};
	}, []);

	return (
		<>
			{applySnap ? (
				<>
					<ServiceAirFreightSnap pageContent={pageContent} />
				</>
			) : (
				<ServiceAirFreightNormal pageContent={pageContent} />
			)}
		</>
	);
}
